// 全局配置文件
export default {
  // 后端服务器地址（用于图片等静态资源）
  // 自动根据当前页面协议选择 HTTP 或 HTTPS
  baseURL: '/dev-api'  // 通过域名代理访问接口
}